import Header from '@components/header/header.component';
import HDivider from '@components/h-divider/h-divider.component';
import GoBackView from '@components/go-back-view/go-back-view';
import View from '@components/view/view';
import { AlertBadge } from '@components/alert-badge/alert-badge';
import { useAuthStore } from '@stores/auth-store';
import { usePaymentsStore } from '@stores/payment-store';

import { useThemeStore } from '../../store';

import styles from './currency-config.module.scss';

const CurrencyConfigView = () => {
    const { theme } = useThemeStore();
    const { exchangeRates } = usePaymentsStore();
    const { permissions } = useAuthStore();

    return (
        <View permissions={permissions} requiredPermission="read-settings">
            <Header
                mode={theme}
                title={'Configuración de monedas'}
                subtitle={
                    'Aquí puedes manejar la tasa de conversión de cada divisa para mostrar los precios de los diferentes planes de PANA en distintas monedas.'
                }
            />
            <HDivider />
            <GoBackView />
            <form className={styles.form}>
                <AlertBadge
                    type="info"
                    text="Las tasas son actualizadas automáticamente desde fuentes oficiales"
                />
                {Object.keys(exchangeRates).map((currency) => (
                    <div key={currency} className={styles.row}>
                        <span className={styles.name}>{currency}</span>
                        <span>→</span>
                        <input
                            defaultValue={exchangeRates[currency].toFixed(2)}
                            className={styles.value}
                            disabled
                        />
                        {currency === 'USD' && (
                            <AlertBadge
                                type="warning"
                                text="Moneda base, tasa siempre será 1.00"
                            />
                        )}
                    </div>
                ))}
            </form>
        </View>
    );
};

export default CurrencyConfigView;
